import type { DeprecatedNumericSpaces } from '../../types';
import { space } from './base';

export const deprecatedSpace: DeprecatedNumericSpaces = {
  0: 0,
  1: space['2x_small'],
  2: space['1x_small'],
  3: space['small'],
  4: space['base'],
  5: space['big'],
  6: space['1x_big'],
  7: space['2x_big'],
  8: space['3x_big'],
  9: 56,
};
